import { useCallback } from "react";
import {
  getContactosCliente,
  grabarContacto,
  AsociarContactoCliente,
} from "../../../services/backend/contactService";

const useBuyerContactAssociation = ({ clienteCodigo, cotizacionId, buyer }) => {
  return useCallback(async () => {
    if (!clienteCodigo) throw new Error("No se encontró el cliente.");
    if (!cotizacionId) throw new Error("No se encontró una cotización activa.");

    const selectedContact =
      buyer.buyerContacts.find(
        (c) =>
          String(c?.id || "").trim() ===
          String(buyer.selectedBuyerContactId || "").trim()
      ) || null;
    const matchingContact =
      selectedContact ||
      buyer.findMatchingBuyerContact(buyer.buyerContacts, buyer.buyerForm);
    let resolvedId = String(matchingContact?.id || "").trim();

    if (!resolvedId) {
      await grabarContacto(
        clienteCodigo,
        String(buyer.buyerForm.Correo || "").trim(),
        0,
        String(buyer.buyerForm.Nombre || "").trim(),
        String(buyer.buyerForm["Teléfono"] || "").trim()
      );
      const response = await getContactosCliente(clienteCodigo);
      const refreshed = Array.isArray(response?.contactos)
        ? response.contactos
        : [];
      buyer.setBuyerContacts(refreshed);
      const created = buyer.findMatchingBuyerContact(
        refreshed,
        buyer.buyerForm
      );
      resolvedId = String(created?.id || "").trim();
      if (!resolvedId)
        throw new Error("No fue posible recuperar el contacto creado.");
      buyer.setSelectedBuyerContactId(resolvedId);
    }
    await AsociarContactoCliente(resolvedId, clienteCodigo);
    return resolvedId;
  }, [clienteCodigo, cotizacionId, buyer]);
};

export default useBuyerContactAssociation;